// globalFilterReducer.js

import { DEFAULT_TIME_RANGE } from "../utils/constants";
import { getRange } from "../utils/utility";

export const initialGlobalFilterState = {
  serialNumber: "",
  siteId: null,
  dateRange: getRange(DEFAULT_TIME_RANGE),
  isSerialNumberConfirmed: false,
};

export default function globalFilterReducer(state, action) {
  switch (action.type) {
    case "SET_GLOBAL_STATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const setAppState = payload => ({
  type: "SET_GLOBAL_STATE",
  payload,
});
